<div class="indicator-content">
  <div class="indicator-header">
    <span class="indicator-title"> <b>Top 10:</b> Rede Credenciada </span>
    <div fxLayoutAlign="end center">
      <indicator-filter (filterDataEvent)="onFilterData($event)"></indicator-filter>
    </div>
  </div>
  <div *ngIf="isLoading" class="loader-container">
    <indicator-loader></indicator-loader>
  </div>
  <div *ngIf="!isLoading" class="indicator-content-container">
    <div class="table-grid table-header">
      <span>Rede Credenciada</span>
      <span>Vendas</span>
    </div>
    <div *ngFor="let network of getTopTenNetworksList(); trackBy: trackByFn" class="table-grid table-body">
      <!-- column 1 -->
      <div class="column-1">
        <img src="./assets/icons/network-icon.svg" />
        <span [matTooltip]="network.networkName">{{ network.networkName }}</span>
      </div>
      <!-- column 2 -->
      <div class="column-2">
        <span>{{ network.networkBalance | currencyPbmPipe }}</span>
      </div>
    </div>
    <div *ngIf="!hasTopTenNetworksData()" class="no-results">
      <p>Não foram encontrados resultados.</p>
    </div>
  </div>
</div>
